<template>
  <el-dialog :title="title" :visible.sync="open" :before-close="close" :append-to-body="true" width="700px">
    <div>
      <div class="container-name">
        <form-group label="Name" required>
          <template slot="input">
            <input name="name" v-model="kpi.name[lang]" placeholder="Name"/>
          </template>
        </form-group>
      </div>

      <div class="container-alias">
        <form-group label="Alias" required>
          <template slot="input">
            <input name="alias" v-model="kpi.alias" placeholder="Alias"/>
          </template>
        </form-group>
      </div>

      <div class="container-action-total">
        <form-group label="Action" required>
          <template slot="input">
            <el-select v-model="kpi.actions" multiple placeholder="Select">
              <el-option
                v-for="event in events"
                :key="event.id"
                :label="event.alias"
                :value="event.alias">
              </el-option>
            </el-select>
          </template>
        </form-group>

        <form-group label="Total" required>
          <template slot="input">
            <el-select v-model="kpi.total" multiple placeholder="Select">
              <el-option
                v-for="event in events"
                :key="event.id"
                :label="event.alias"
                :value="event.alias">
              </el-option>
            </el-select>
          </template>
        </form-group>
      </div>

    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close" plain >{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="save()" :loading="isSaving">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import formGroup from '@/components/layouts/form-group.vue'

export default {
  name: 'kpi-form',
  props: {
    id: {
      type: String,
      required: false
    },
    open: {
      type: Boolean,
      required: true
    }
  },

  components: { formGroup },

  data () {
    return {
      kpi: {},
      isSaving: false
    }
  },

  computed: {
    ...mapGetters('kpis', {
      getById: 'getById'
    }),
    ...mapGetters('account', {
      lang: 'defaultLang',
      site: 'currentSite'
    }),

    ...mapState('events', {
      events: 'items'
    }),

    title () {
      if (this.id) {
        return 'Edit a kpi'
      } else {
        return 'Create a kpi'
      }
    }
  },
  methods: {
    ...mapActions('kpis', ['addKpi', 'updateKpi']),
    ...mapActions('events', ['loadEvents']),
    save () {
      this.isSaving = true
      if (!this.id) {
        this.addKpi({kpi: this.kpi}).then(() => {
          this.$notify({
            title: 'Success',
            message: this.$root.$t('notifications.advice.kpiAdded'),
            type: 'success'
          })
          this.close()
        }).catch((response) => {
          this.$notify.error({
            title: this.$root.$t('api.' + response.code + '.title'),
            message: this.$root.$t('api.' + response.code + '.message')
          })
          this.isSaving = false
        })
      } else {
        this.updateKpi({kpi: this.kpi}).then(() => {
          this.$notify({
            title: 'Success',
            message: this.$root.$t('notifications.advice.kpiEdited'),
            type: 'success'
          })
          this.close()
        }).catch((response) => {
          this.$notify.error({
            title: this.$root.$t('api.' + response.code + '.title'),
            message: this.$root.$t('notifications.advice.kpiAdded')
          })
          this.isSaving = false
        })
      }
    },

    close () {
      this.isSaving = false
      this.$emit('close')
    }
  },
  created () {
    this.loadEvents()

    if (this.id) {
      this.kpi = this._.cloneDeep(this.getById(this.id), false)
    } else {
      this.kpi = {
        actions: [],
        total: [],
        alias: null,
        name: {}
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/advice/kpi-form.vue